import React, { memo } from 'react';
import { Box, Grid, Skeleton, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { VictoryPie } from 'victory';
import useTheme from '@mui/styles/useTheme';
import { useMessage } from 'modules/intl';
import { useChartStyles } from './hooks/useChartStyles';

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    marginTop: theme.spacing(0),
    marginLeft: theme.spacing(0),
    height: theme.spacing(20),
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  legendRows: {
    paddingLeft: theme.spacing(1)
  },
  bulletIcon: {
    marginRight: theme.spacing(1),
    height: theme.spacing(1.25),
    width: theme.spacing(1.25)
  },
  pieContainer: {
    marginLeft: theme.spacing(0),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0.5),
    height: theme.spacing(25)
  }
}));

export const LabelNoData: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const chartStyle = useChartStyles(theme);
  const na = useMessage('insights.timeSheetLabels.na');
  return (
    <Grid container direction="row">
      <Grid
        container
        item
        xs={6}
        justifyContent="center"
        alignContent="center"
        data-testid="label-chart-pie-no-data-container"
      >
        <Box className={classes.pieContainer}>
          <VictoryPie
            data={[{ x: 1, y: 1, color: theme.palette.insights.noData }]}
            innerRadius={chartStyle.VictoryChartNoData.innerRadius}
            width={chartStyle.VictoryChartNoData.width}
            labels={() => ''}
            style={{
              data: {
                fill: ({ datum }) => datum.color
              }
            }}
            data-testid="label-chart-pie-no-data"
          />
        </Box>
      </Grid>
      <Grid container item xs={6}>
        <Box className={classes.legendContainer}>
          {[...Array(5)].map((_i, index) => (
            <Grid
              container
              className={classes.legendRows}
              key={JSON.stringify(index)}
            >
              <Grid
                item
                xs={12}
                container
                alignItems="center"
                data-testid="label-chart-legend-no-data"
              >
                <Skeleton
                  variant="circular"
                  className={classes.bulletIcon}
                  animation={false}
                />
                <Typography variant="body1">{na}</Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};
export default memo(LabelNoData);
